import { Order } from "../../../Utilities/SortableTableHead";
import OrganisationTableRowViewModel from "./OrganisationTableRowViewModel";

// MUST follow camelCase naming convention as this populates the chip names in the dialog
export default class SearchFilterViewModel {
    public quickSearch: string | null = null;

    // string search
    public organisation: string | null = null;
    public memberNumber: string | null = null;
    public officeName: string | null = null;
    public officeTown: string | null = null;
    public officeRegion: string | null = null;
    public officeCountry: string | null = null;
    public invoicePayee: string | null = null;

    // dropdown search
    public licenseType: string | null = null;
    public invoicePayments: string | null = null;
    public invoicePayMethod: string | null = null;
    public invoiceNotice: string | null = null;
    public estimateNotice: string | null = null;
    public expiryDate: DateRange | null = null;
 
    // flag search
    // public administratorSitesOnly: boolean | null = null;
    public active: boolean | null = null;   
    public archivedOnly: boolean = false;

    // grid settings
    public pageNumber: number = 0;
    public rowsPerPage: number = 20;
    public order: Order = 'asc';
    public orderBy: keyof OrganisationTableRowViewModel = 'organisationName';
    public orderByProp: string | null = 'OrganisationName';
}

class DateRange {
    public start: Date | null = null;
    public end: Date | null = null;
}
